module.exports = __webpack_public_path__ + "img/arrow-down-to-square.323cf842.svg";